import { type IValidationSchema, validationContext } from 'validx'
import type { LegendPartDependencies } from '@/features/legends/editor/legend-part-dependencies'
import { RoutingContextSourceEditorViewModelBase } from '@/features/legends/data-sources/RoutingContextSourceEditorViewModelBase'
import { Types } from '@/features/legends/editor/ryno-types'
import type { UserWorkRequestCountSource } from '@/features/legends/data-sources/data-sources'

/**
 * The candidate's number of work requests.
 */
export class UserWorkRequestCountEditorViewModel extends RoutingContextSourceEditorViewModelBase<UserWorkRequestCountSource> {
  private readonly _schema: IValidationSchema<UserWorkRequestCountEditorViewModel> =
    {
      id: RoutingContextSourceEditorViewModelBase.idValidation.validators,
    }

  readonly type = 'UserWorkRequestCount'
  readonly valueType = Types.number
  readonly validation = validationContext(this, this._schema)

  constructor(dependencies: LegendPartDependencies) {
    super(dependencies, 'USER_WORK_REQUEST_COUNT')
  }

  /** @inheritDoc */
  toJSON(): UserWorkRequestCountSource {
    return { type: this.type, id: this.id }
  }
}
